// src/components/EditarTareaModal.js

import React, { useState, useEffect } from 'react';
import apiClient from '../services/api';
import { toast } from 'react-toastify';
import Button from './Button';

function EditarTareaModal({ tarea, ninos, onClose, onTareaActualizada }) {
  const [titulo, setTitulo] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [puntos, setPuntos] = useState(10);
  const [categoria, setCategoria] = useState('HOGAR');
  const [asignadaA, setAsignadaA] = useState('');
  const [error, setError] = useState('');

  // Cuando el modal se abre, rellenamos el formulario con los datos de la tarea
  useEffect(() => {
    if (tarea) {
      setTitulo(tarea.titulo);
      setDescripcion(tarea.descripcion);
      setPuntos(tarea.puntos);
      setCategoria(tarea.categoria);
      setAsignadaA(tarea.asignada_a);
    }
  }, [tarea]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const tareaActualizada = { 
        titulo, 
        descripcion, 
        puntos, 
        categoria, 
        asignada_a: asignadaA,
        tipo: tarea.tipo // Mantenemos el tipo original
      };
      await apiClient.put(`/tareas/${tarea.id}/`, tareaActualizada);
      toast.success('¡Tarea actualizada!');
      onTareaActualizada();
      onClose();
    } catch (err) {
      setError('No se pudo actualizar la tarea.');
      console.error(err);
    }
  };

  if (!tarea) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-8 rounded-2xl shadow-lg w-full max-w-md">
        <h2 className="text-2xl font-bold text-principal mb-6">Editar Tarea 🪄</h2>
        <form onSubmit={handleSubmit}>
          {/* ... (el resto del formulario es idéntico al de creación) ... */}
          <div className="mb-4">
            <label className="block text-gray-700 font-bold mb-2">Título</label>
            <input type="text" value={titulo} onChange={(e) => setTitulo(e.target.value)} className="w-full px-3 py-2 border rounded-lg" required />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-bold mb-2">Descripción</label>
            <textarea value={descripcion} onChange={(e) => setDescripcion(e.target.value)} className="w-full px-3 py-2 border rounded-lg" rows="2"></textarea>
          </div>
          <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
                <label className="block text-gray-700 font-bold mb-2">Puntos ✨</label>
                <input type="number" value={puntos} onChange={(e) => setPuntos(e.target.value)} className="w-full px-3 py-2 border rounded-lg" required min="1" />
            </div>
            <div>
                <label className="block text-gray-700 font-bold mb-2">Categoría</label>
                <select value={categoria} onChange={(e) => setCategoria(e.target.value)} className="w-full px-3 py-2 border rounded-lg bg-white">
                    <option value="HOGAR">Hogar</option>
                    <option value="ESCUELA">Escuela</option>
                    <option value="HABITOS">Hábitos</option>
                </select>
            </div>
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 font-bold mb-2">Asignada a:</label>
            <select value={asignadaA} onChange={(e) => setAsignadaA(e.target.value)} className="w-full px-3 py-2 border rounded-lg bg-white" required>
              {ninos.map(nino => (<option key={nino.id} value={nino.id}>{nino.username}</option>))}
            </select>
          </div>
          {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
          <div className="flex justify-end gap-4">
            <Button type="button" variant="secondary" onClick={onClose}>Cancelar</Button>
            <Button type="submit" variant="accent">Guardar Cambios</Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditarTareaModal;